
import Layout from '@/components/layout/Layout';
import { Card, CardContent } from '@/components/ui/card';

const About = () => {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-display font-bold mb-4">About Agents of Learning</h1>
          <p className="text-xl text-muted-foreground">
            Connecting learners with AI agents for meaningful educational experiences
          </p>
        </div>
        
        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-display font-bold mb-4">Our Mission</h2>
            <Card className="glass">
              <CardContent className="p-6">
                <p className="leading-relaxed">
                  Agents of Learning aims to create a platform where people can engage with specialized 
                  AI learning agents, each designed with unique expertise. Our mission is to provide thoughtful, 
                  enriching educational experiences that help users explore new subjects, gain different perspectives, 
                  and enjoy meaningful interactions that enhance their learning journey.
                </p>
              </CardContent>
            </Card>
          </section>
          
          <section>
            <h2 className="text-2xl font-display font-bold mb-4">Powered by Claude</h2>
            <Card className="glass">
              <CardContent className="p-6">
                <p className="leading-relaxed mb-4">
                  Our learning agents are powered by Claude, a state-of-the-art AI assistant developed by Anthropic. 
                  Claude is designed to be helpful, harmless, and honest, making it the perfect foundation 
                  for our diverse range of AI educators.
                </p>
                <p className="leading-relaxed">
                  Each of our agents is built with carefully crafted system prompts that give them their 
                  unique teaching style and expertise, while maintaining Claude's core values of safety and reliability.
                </p>
              </CardContent>
            </Card>
          </section>
          
          <section>
            <h2 className="text-2xl font-display font-bold mb-4">Bluesky Authentication</h2>
            <Card className="glass">
              <CardContent className="p-6">
                <p className="leading-relaxed">
                  We use Bluesky for authentication, providing a secure and seamless way for users to 
                  access our platform. Your Bluesky account is used to keep track of your learning sessions 
                  with our agents, ensuring a personalized experience while maintaining your privacy.
                </p>
              </CardContent>
            </Card>
          </section>
          
          <section>
            <h2 className="text-2xl font-display font-bold mb-4">Our Values</h2>
            <div className="grid md:grid-cols-3 gap-4">
              <Card className="glass">
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-medium mb-2">Quality</h3>
                  <p className="text-muted-foreground">
                    We prioritize meaningful, thoughtful educational experiences over quantity.
                  </p>
                </CardContent>
              </Card>
              
              <Card className="glass">
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-medium mb-2">Diversity</h3>
                  <p className="text-muted-foreground">
                    We offer a wide range of learning agents to cater to different subjects and learning styles.
                  </p>
                </CardContent>
              </Card>
              
              <Card className="glass">
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-medium mb-2">Privacy</h3>
                  <p className="text-muted-foreground">
                    We respect user privacy and ensure secure handling of learning session data.
                  </p>
                </CardContent>
              </Card>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default About;
